
export const DocumentUtils = {
  scrollTop: (divId) => {
    if (!divId) {
      window.scrollTo(0, 0);
      return;
    }
    const divSelected = document.getElementById(divId);
    divSelected.scrollTop = 0;
  }
};



// WEBPACK FOOTER //
// ./src/utils/DocumentUtils.js